import React from 'react';
import PageContentLayout from '../components/layouts/PageContentLayout';
import { RULES_URL } from '../config';
import { useTranslation } from 'react-i18next';

const RulesPage = () => {
    const { t } = useTranslation();

    return (
        <PageContentLayout title={t('menu.rules')} icon='rule-icon'>
            <iframe
                title='rules'
                src={RULES_URL}
                frameborder="0"
                allowfullscreen
                className='external-data'
                style={{ height: '65vh' }}
            ></iframe>
        </PageContentLayout>
    );
};

export default RulesPage;
